module.exports = __webpack_public_path__ + "static/media/Happy-Munin2.d7b4e567.svg";